import { validate } from 'uuid';

export const getScheduleIdFromSlug = (slug: string): string => {
  // The schedule id is the UUID at the end of the slug. Strip trailing
  // punctuation/whitespace before matching: shared links occasionally pick up a
  // stray comma or period when a URL is pasted mid-sentence, which would
  // otherwise make a slug carrying a perfectly valid UUID throw "UUID not found
  // in schedule slug" (Sentry WEB-CLIENT-278). The match stays end-anchored so a
  // UUID must genuinely terminate the slug (ignoring that trailing punctuation).
  const trimmed = slug.replace(/[^0-9A-Za-z]+$/, '');
  const uuid = trimmed.match(
    /[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i
  )?.[0];
  if (!uuid) {
    throw new Error('UUID not found in schedule slug');
  }
  if (!validate(uuid)) {
    throw new Error('Schedule slug UUID is invalid');
  }
  return uuid;
};

/**
 * Some /schedule/:slug URLs don't carry a schedule at all — e.g.
 * /schedule/category/ai, where ":slug" greedily captures "category" and
 * "ai" is a wildcard route segment rather than part of the slug (Sentry
 * WEB-CLIENT-278). Route those to the same "not found" state as a real but
 * deleted schedule, rather than letting the UUID parse throw and crash to
 * the generic route error screen.
 */
export const slugHasScheduleId = (slug: string): boolean => {
  try {
    getScheduleIdFromSlug(slug);
    return true;
  } catch {
    return false;
  }
};
